import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/color-picker.svg
 */
const IconColorPicker: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.111 11.98L11.957 7.8l-7.966 8.016v4.18h4.154l7.966-8.016zm2.816 0l-6.97-7.013-9.52 9.579c-.28.282-.437.664-.437 1.063v5.389A.999.999 0 002.996 22H8.35c.397 0 .776-.158 1.057-.44l9.52-9.58z"
      fill="currentColor"
    />
    <path
      d="M9.89 3.442a.496.496 0 01.704 0l9.918 9.98a.503.503 0 010 .708l-1.067 1.073a.496.496 0 01-.704 0l-9.917-9.98a.503.503 0 010-.708L9.89 3.442z"
      fill="currentColor"
    />
    <path
      d="M16.398 2.293a.991.991 0 011.408 0l3.902 3.927a1.007 1.007 0 010 1.417l-3.721 3.745-5.31-5.344 3.72-3.745z"
      fill="currentColor"
    />
  </svg>
);

export default IconColorPicker;
